const MarginBox = ()=>{
    return <div className="box-center">
        
    </div>
}

export default MarginBox